"use client";

import React from "react";
import { ShieldCheck, Info, Hammer, Armchair, Trash2, Sparkles, Brush, Phone, MessageCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
const guarantees = [{
  icon: Hammer,
  title: "Outdoor Assembly",
  description: "Professional assembly of gazebos, sheds, and play structures for your Sacramento backyard and outdoor spaces."
}, {
  icon: Armchair,
  title: "Furniture Assembly",
  description: "Expertly putting together IKEA, Wayfair, and Amazon furniture in Sacramento homes with speed and precision."
}, {
  icon: Trash2,
  title: "Floor & Carpet Removal",
  description: "Efficiently removing old flooring and carpeting across Sacramento neighborhoods with zero mess left behind."
}, {
  icon: Sparkles,
  title: "Deep Carpet Cleaning",
  description: "Restoring the beauty of your Sacramento carpets with professional-grade deep cleaning and stain removal technology."
}, {
  icon: Brush,
  title: "Wood Floor Treatment",
  description: "Specialized care and treatment for wood floors in Sacramento to ensure a lasting, luxurious shine and protection."
}, {
  icon: ShieldCheck,
  title: "Master Craftsmanship",
  description: "Meticulous attention to detail on assembly and cleaning services for a professional Sacramento finish every time."
}];
export default function TheCraigsGuarantee() {
  return <section data-section-id="125278" id="the-kim-julio-difference" className="dark bg-background border-y border-border py-16 md:py-20">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {guarantees.map((item, i) => {
          const Icon = item.icon;
          const tooltipContent = (item as any).tooltip;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-6 p-5 bg-primary/20 rounded-full text-primary transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground shadow-lg shadow-primary/5">
                  <Icon className="w-10 h-10" strokeWidth={1.5} />
                </div>
                
                <h3 className="text-xl font-default font-extrabold tracking-tight text-foreground mb-3 flex items-center justify-center gap-2">
                  {tooltipContent ? <TooltipProvider delayDuration={300}>
                      <Tooltip>
                        <TooltipTrigger className="flex items-center gap-1.5 cursor-help hover:text-primary transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm">
                          {item.title}
                          <Info className="w-4 h-4 text-primary animate-pulse" />
                        </TooltipTrigger>
                        <TooltipContent side="top" className="max-w-[250px] text-center bg-card border-border">
                          <p className="font-default text-sm">{tooltipContent}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider> : item.title}
                </h3>
                
                <p className="text-muted-foreground font-default leading-relaxed max-w-[280px]">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button size="lg" className="w-full sm:w-auto gap-2 font-bold px-8 bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300">
            <Phone className="w-5 h-5" />
            Call Now
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto gap-2 font-bold px-8 border-primary text-primary hover:bg-primary/10 transition-all duration-300">
            <MessageCircle className="w-5 h-5" />
            WhatsApp Us
          </Button>
        </div>
      </div>
    </section>;
}